/* eslint camelcase: "off" */
import React from 'react'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import PropTypes from 'prop-types'
import { httpLink, authLink, cacheKeys } from '../shared/ApolloClient'
import QuestionsWrapper from './QuestionsWrapper'

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(cacheKeys)
})

const Layout = ({ loan_id, is_paycheck_protection, is_editable, is_eligibilty = true }) => (
  <ApolloProvider client={client}>
    <QuestionsWrapper
      loanId={loan_id}
      isPaycheckProtection={is_paycheck_protection}
      isEditable={is_editable}
      isEligibility={is_eligibilty}
    />
  </ApolloProvider>
)

Layout.propTypes = {
  loan_id: PropTypes.number.isRequired
}

export default Layout
